import { memo, useCallback, useMemo } from "react";

import { EditGuideTooltip } from "@/components/features/items/edit/_shared/ui/components/system/tooltip/edit-guide-tooltip";

import { Button } from "@/components/ui/button/button";
import { Label } from "@/components/ui/label/label";

type Props = {
	statusNoShow: boolean;
	//
	onUpdate: (statusNoShow: boolean) => void;
};

export const GuestStatusOfManagementStatusCompositions = memo(({ statusNoShow, onUpdate }: Props) => {
	/**
	 * お客様のステータスが NoShow かどうか
	 */
	const isNoShow = useMemo(() => {
		return statusNoShow;
	}, [statusNoShow]);
	/**
	 * お客様のステータスを更新
	 */
	const handleClickUpdateNoShow = useCallback(() => {
		const confirmText = isNoShow
			? "お客様のステータス「NO SHOW」を取り消しますか？"
			: "お客様のステータスを「NO SHOW」に変更しますか？";
		if (window.confirm(confirmText)) {
			// 更新
			onUpdate(!isNoShow);
		}
	}, [isNoShow, onUpdate]);

	return (
		<div className="w-full space-y-2">
			<div className="flex items-center gap-2">
				<p>お客様のステータス</p>

				<EditGuideTooltip
					guide={`
            <b>NO SHOWについて</b>
            <br />
            お客様がチェックインされなかった場合に設定するステータスです。
            <br /><br />
            <b>現地決済の場合</b>
            <br />
            NO SHOWに設定すると、チェックイン翌日16時までキャンセル操作が可能になります。
          `}
				/>
			</div>

			<div className="flex items-center gap-x-5">
				<Label text="NO SHOW" variant={isNoShow ? "required" : "black"} />

				<Button variant="outline" type="button" size="sm" onClick={handleClickUpdateNoShow}>
					変更
				</Button>
			</div>
		</div>
	);
});
